// eslint-disable-next-line no-debugger
import React from "react"
import { graphql } from "gatsby"
import Helmet from "react-helmet"
import Layout from "../components/Layout/layout"
import {
  TopFeature,
  ExecutiveMessage,
  Roadmap,
  CompanyHistory,
  CompanyBoard,
  CompanyInformation,
} from "../components/top"

const WebPage = ({ location, pageContext: {language: lang}, data: { site }}) => {
  const jsonld = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "url": "https://autify.com/",
    "logo": "https://autify.com/autify-logo.png"
  }

  return (
    <Layout location={location} hasCTA={false} isCorporateHeader={true}>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(jsonld)}
        </script>
      </Helmet>

      <div style={{marginTop: '100px'}}>
        <TopFeature language={lang} />
      </div>

      <section className="p-0">
        <ExecutiveMessage language={lang} />
      </section>

      <div style={{backgroundColor: '#f6f9fb'}}>
        <Roadmap language={lang} />
      </div>

      <div className="container">
        <CompanyHistory language={lang} />
      </div>

      <div style={{backgroundColor: '#f6f9fb'}}>
        <CompanyBoard language={lang} />
      </div>

      <div>
        <CompanyInformation language={lang} />
      </div>
    </Layout>
  )
}
export default WebPage

export const query = graphql`
  query {
    site {
      siteMetadata {
        domain
      }
    }
  }
`
